module.exports = __webpack_public_path__ + "static/sss-icon-27c40bffd9df0c980cf7bee6b41cb453.png";